<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <ButtonClose @click="handleClose" />
    </div>
    <div :class="$style.simulationContainer">
      <iframe
        allowfullscreen
        :class="$style.simulation"
        frameborder="0"
        :src="iframeSrc"
      />
    </div>
    <div
      :class="$style.footer"
    >
      <Button
        :class="$style.newTabLink"
        hasNoBackground
        :outline="false"
        :text="openInNewTabText"
        textCase="lowercase"
        type="informational"
        @click="openInNewTabClicked"
      />
    </div>
  </div>
</template>

<script>
import {
  Button,
  ButtonClose,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const {
  description,
  location,
  text,
  toUrl,
} = eventProperties;
const { simulationModal } = eventLocations;

export default {
  name: 'SimulationModal',

  components: {
    Button,
    ButtonClose,
  },

  EventHelper,
  ModalEventBus,
  Util,

  props: {
    iframeSrc: {
      type: String,
      required: true,
    },

    simulationUrl: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    openInNewTabText: 'open simulation in a new tab',
  }),

  methods: {
    handleClose() {
      this.$options.ModalEventBus.close();
    },

    openInNewTabClicked() {
      this.$options.EventHelper.triggerLinkClicked({
        [description]: 'Opens simulation in a new tab',
        [location]: simulationModal,
        [text]: this.openInNewTabText,
        [toUrl]: this.simulationUrl,
      });

      this.$options.Util.openUrl(this.simulationUrl);
    },
  },
};
</script>

<style module scoped>
.header {
  float: right;
  padding: 20px;
}

.simulationContainer {
  margin-top: 60px;
  overflow: hidden;
  padding-top: 56.25%; /* This assumes the video has a 16:9 aspect ratio */
  position: relative;
  width: 100%;
}

.simulation {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.footer {
  margin: 20px;
}

.newTabLink.newTabLink {
  font-size: 16px;
  font-weight: 400;
}
</style>
